import { TextField } from '@mui/material';

export const AlpsNoteField = ({ note, onChange, loading = false, disableActions = false }) => {
    return (
        <TextField
            fullWidth
            multiline
            rows={8}
            variant="outlined"
            label="ALPS Note"
            placeholder="Enter project details such as duration, special requirements, etc..."
            value={note}
            onChange={(e) => !disableActions && onChange(e.target.value)}
            disabled={loading}
            InputLabelProps={{
                shrink: true,
            }}
            InputProps={{
                readOnly: disableActions,
                style: {
                    fontSize: '14px',
                    lineHeight: 1.6,
                },
            }}
            sx={{
                '& .MuiInputBase-input': {
                    fontFamily: 'monospace',
                    whiteSpace: 'pre-wrap',
                    lineHeight: 1.6,
                    fontSize: '14px',
                },
                '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                        borderColor: '#e0e0e0',
                    },
                    '&:hover fieldset': {
                        borderColor: '#1976d2',
                    },
                },
                backgroundColor: 'white',
            }}
        />
    );
};
